import { getMaxCampaignLevel, hasCampaignLevel } from "../level_config.js";
import { LevelPackService } from "./level_pack_service.js";
import { NetworkManager } from "../network_manager.js";
import { DialogManager } from "../ui/dialog/dialog_manager.js";
import { NoLevelsDialog } from "../ui/dialog/no_levels_dialog.js";
import { StartupImagePlan } from "../image_loader/startup_image_plan.js";

export function explainMissingCampaignLevel( level: number ): void
{
  if ( LevelPackService.isActive() && level > getMaxCampaignLevel() )
  {
    // Its art is among the last startup groups to load.
    StartupImagePlan.runWhenReady( () => NoLevelsDialog.open() );
    return;
  }

  if ( !NetworkManager.isOnline() )
  {
    NetworkManager.showOfflineLevelsExhausted();
    return;
  }

  NetworkManager.handleLoadingDataError(
    new Error(
      LevelPackService.isActive()
        ? `[LevelPack] level ${level} is missing from release ${LevelPackService.getReleaseUid() ?? "?"}`
        : `[LevelPack] no server release available for level ${level}`
    )
  );

  void LevelPackService.refresh().then( () =>
  {
    if ( hasCampaignLevel( level ) )
    {
      console.info( `[LevelPack] level ${level} arrived on retry` );
      NetworkManager.clearLoadingError();
    }
  } );
}
